'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EU_AMOUNTS = [30, 60, 120];
var SIRU_NOK_AMOUNTS = [36, 45, 60, 120];
var SIRU_SEK_AMOUNTS = [35, 70, 105, 140];
var SIRU_DEFAULT_AMOUNTS = [5, 15];
var DEFAULT_AMOUNTS = [300, 600, 1200];

var getSupportedAmounts = exports.getSupportedAmounts = function getSupportedAmounts(currency, providerType) {
  var amounts = DEFAULT_AMOUNTS;

  if (['eur', 'cad', 'nzd', 'chf', 'gbp'].indexOf(currency.toLowerCase()) > -1) amounts = EU_AMOUNTS;

  if (providerType) {
    if (providerType.toLowerCase() === 'siru' && currency.toLowerCase() === 'nok') amounts = SIRU_NOK_AMOUNTS;else if (providerType.toLowerCase() === 'siru' && currency.toLowerCase() === 'sek') amounts = SIRU_SEK_AMOUNTS;else if (providerType.toLowerCase() === 'siru') amounts = SIRU_DEFAULT_AMOUNTS;
  }

  return amounts;
};

var matchProviderType = exports.matchProviderType = function matchProviderType(first, second) {
  var fType = first.providerType;
  var sType = second.providerType;


  if (first.service) fType = fType + first.service;
  if (second.service) sType = sType + second.service;

  if (!fType || !sType) return;

  return sType.toLowerCase() === fType.toLowerCase();
};